// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-plan-container {
  box-sizing: border-box;
  min-width: 100%;
}

.select-plan-container .title {
  margin-bottom: 24px;
  font-size: 28px;
  font-weight: 700;
  line-height: 33.6px;
  text-align: center;
}

.select-plan-container .plan-container {
  --floating-container-width: 100%;
  --floating-container-border: 1px;
  --floating-container-border-radius: 16px;

  border: var(--floating-container-border) solid var(--gray);
  border-radius: var(--floating-container-border-radius);
  box-shadow: 4px 6px 12px 0 #181C2714;

  backdrop-filter: blur(3.92342px);

  position: relative;
  margin-top: 16px;
  padding-left: 34px;

  height: 116px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 340px;

  box-sizing: border-box;
  cursor: pointer;
}

.select-plan-container .radio-button {
  position: absolute;
  left: 24px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  appearance: none;
  cursor: pointer;
  border: 1px solid var(--dark-gray);
  background-color: transparent;
}

.select-plan-container .plan-container.selected .radio-button {
  background-color: var(--green-mint);
  border: 1px solid var(--green-mint);
  padding: 3px;
  background-clip: content-box;
}

.select-plan-container .plan-container.selected {
  border-color: var(--orange);
  background-color: var(--white);
}

.plan-container.extra .extra-top {
  max-width: fit-content;
  position: absolute;
  background-color: var(--dark-gray);
  padding: 5px 12px;
  border-radius: 24px;
  font-size: 12px;
  font-weight: 600;
  line-height: 14.52px;
  color: white;
  left: 55px;
  right: 0;
  top: 14px;
}

.select-plan-container .plan-container.extra.selected .extra-top {
  background: var(--orange);
}

.plan-container .plan-inner-container {
  height: 100%;
  min-height: 100%;
  display: flex;
  justify-content: space-between;
}

.plan-container .price-info-container {
  padding-top: 30px;
  margin-left: 22px;
}

.plan-container.extra .price-info-container {
  padding-top: 50px;
}

.plan-container .plan-name {
  margin-bottom: 16px;
  font-size: 17px;
  font-weight: 600;
  line-height: 20.57px;
  text-align: left;
  color: var(--dark-silver);
}

.plan-container.selected .plan-name {
  font-weight: 700;
  color: var(--black);
}

.plan-container .price-alt {
  display: flex;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  color: var(--dark-gray);
}

.plan-container .price-alt .price.crossed {
  text-decoration: line-through;
  color: var(--green-mint);
}

.plan-container .period-price-container {
  margin-left: auto;
  min-width: 65px;
  font-size: 26px;
  font-weight: 700;
  line-height: 31.2px;
  padding-top: 30px;
  text-align: center;
  color: var(--dark-silver);
}

#content.ja .plan-container .period-price-container {
  padding-right: 30px;
}

.plan-container.selected .period-price-container {
  color: var(--black);
}

.plan-container.extra .period-price-container {
  padding-top: 42px;
}

.plan-container .period-price-container sup {
  font-size: 100%;
  top: auto;
  margin-left: -30px;
}

.plan-container .period-price-container sub {
  left: -2.5em;
  bottom: -1.7em;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  color: var(--dark-gray)
}

.plan-container .period-price-container .crossed-period-price {
  display: block;
  margin-right: 14px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  top: -0.8em;
  left: 1px;

  color: var(--light-dark-silver);
  text-decoration: line-through var(--light-dark-silver);
  -webkit-text-decoration: line-through var(--light-dark-silver);
}

.select-plan-block .money-back-information {
  margin: 24px auto 16px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
}

.select-plan-block .money-back-information .item + .item {
  margin-top: 13px;
}

.select-plan-block .money-back-information .item {
  margin: 16px 16px 0;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.select-plan-block .money-back-information .item img {
  width: 16px;
}

.select-plan-block .money-back-information .item .text {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
}

.select-plan-block .money-back-information .item .text > a {
  color: var(--orange);
}

.select-plan-block .money-back-information .button-container button {
  border-radius: 12px;
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.select-plan.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,wCAAwC;;EAExC,0DAA0D;EAC1D,sDAAsD;EACtD,oCAAoC;;EAEpC,gCAAgC;;EAEhC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;;EAEhB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;;EAET,+BAA+B;EAC/B,sDAAsD;EACtD,8DAA8D;AAChE;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".select-plan-container {\n  box-sizing: border-box;\n  min-width: 100%;\n}\n\n.select-plan-container .title {\n  margin-bottom: 24px;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 33.6px;\n  text-align: center;\n}\n\n.select-plan-container .plan-container {\n  --floating-container-width: 100%;\n  --floating-container-border: 1px;\n  --floating-container-border-radius: 16px;\n\n  border: var(--floating-container-border) solid var(--gray);\n  border-radius: var(--floating-container-border-radius);\n  box-shadow: 4px 6px 12px 0 #181C2714;\n\n  backdrop-filter: blur(3.92342px);\n\n  position: relative;\n  margin-top: 16px;\n  padding-left: 34px;\n\n  height: 116px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 340px;\n\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\n.select-plan-container .radio-button {\n  position: absolute;\n  left: 24px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  appearance: none;\n  cursor: pointer;\n  border: 1px solid var(--dark-gray);\n  background-color: transparent;\n}\n\n.select-plan-container .plan-container.selected .radio-button {\n  background-color: var(--green-mint);\n  border: 1px solid var(--green-mint);\n  padding: 3px;\n  background-clip: content-box;\n}\n\n.select-plan-container .plan-container.selected {\n  border-color: var(--orange);\n  background-color: var(--white);\n}\n\n.plan-container.extra .extra-top {\n  max-width: fit-content;\n  position: absolute;\n  background-color: var(--dark-gray);\n  padding: 5px 12px;\n  border-radius: 24px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 14.52px;\n  color: white;\n  left: 55px;\n  right: 0;\n  top: 14px;\n}\n\n.select-plan-container .plan-container.extra.selected .extra-top {\n  background: var(--orange);\n}\n\n.plan-container .plan-inner-container {\n  height: 100%;\n  min-height: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.plan-container .price-info-container {\n  padding-top: 30px;\n  margin-left: 22px;\n}\n\n.plan-container.extra .price-info-container {\n  padding-top: 50px;\n}\n\n.plan-container .plan-name {\n  margin-bottom: 16px;\n  font-size: 17px;\n  font-weight: 600;\n  line-height: 20.57px;\n  text-align: left;\n  color: var(--dark-silver);\n}\n\n.plan-container.selected .plan-name {\n  font-weight: 700;\n  color: var(--black);\n}\n\n.plan-container .price-alt {\n  display: flex;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14.52px;\n  color: var(--dark-gray);\n}\n\n.plan-container .price-alt .price.crossed {\n  text-decoration: line-through;\n  color: var(--green-mint);\n}\n\n.plan-container .period-price-container {\n  margin-left: auto;\n  min-width: 65px;\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 31.2px;\n  padding-top: 30px;\n  text-align: center;\n  color: var(--dark-silver);\n}\n\n#content.ja .plan-container .period-price-container {\n  padding-right: 30px;\n}\n\n.plan-container.selected .period-price-container {\n  color: var(--black);\n}\n\n.plan-container.extra .period-price-container {\n  padding-top: 42px;\n}\n\n.plan-container .period-price-container sup {\n  font-size: 100%;\n  top: auto;\n  margin-left: -30px;\n}\n\n.plan-container .period-price-container sub {\n  left: -2.5em;\n  bottom: -1.7em;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14.52px;\n  color: var(--dark-gray)\n}\n\n.plan-container .period-price-container .crossed-period-price {\n  display: block;\n  margin-right: 14px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n  top: -0.8em;\n  left: 1px;\n\n  color: var(--light-dark-silver);\n  text-decoration: line-through var(--light-dark-silver);\n  -webkit-text-decoration: line-through var(--light-dark-silver);\n}\n\n.select-plan-block .money-back-information {\n  margin: 24px auto 16px;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 150%;\n}\n\n.select-plan-block .money-back-information .item + .item {\n  margin-top: 13px;\n}\n\n.select-plan-block .money-back-information .item {\n  margin: 16px 16px 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.select-plan-block .money-back-information .item img {\n  width: 16px;\n}\n\n.select-plan-block .money-back-information .item .text {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n}\n\n.select-plan-block .money-back-information .item .text > a {\n  color: var(--orange);\n}\n\n.select-plan-block .money-back-information .button-container button {\n  border-radius: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
